"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createContext_1 = require("../utils/createContext");
var query_string_1 = __importDefault(require("query-string"));
var invariant_1 = __importDefault(require("invariant"));
var Experiment = /** @class */ (function (_super) {
    __extends(Experiment, _super);
    function Experiment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Experiment.prototype.redirector = function (redirectQuery, history) {
        if (typeof window != "undefined") {
            var parsed = query_string_1.default.parse(location.search);
            var newPart = __assign({}, parsed, this.context.abTest.queryPart);
            var newUrlPart = query_string_1.default.stringify(newPart);
            if (newUrlPart != query_string_1.default.extract(location.href)) {
                if (history) {
                    history.replace({
                        search: newUrlPart
                    });
                }
                else {
                    window.location.search = newUrlPart;
                }
            }
        }
    };
    Experiment.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, experimentName = _a.name;
        return (react_1.default.createElement(createContext_1.Consumer, null, function (value) {
            invariant_1.default(value.abTest, "You should not use <Experiment> outside a <AB_Provider>");
            var selectedVariant = value.abTest.getVariant(experimentName);
            //TODO проверить на правильность
            if (selectedVariant == undefined) {
                return null;
            }
            var arrayChild = react_1.default.Children.toArray(children);
            var renderChild = arrayChild.find(function (o) { return o.props.name == selectedVariant.variant.name; });
            // Проверяем правильность URL
            var redirectQuery = "";
            var isRedirect = false;
            var location = null;
            if (value.location) {
                location = value.location;
            }
            else if (typeof window != "undefined") {
                location = window.location;
            }
            else {
                throw new Error("Location not defined, use createLocation from package History and set this on AB_Provider");
            }
            var parsed = query_string_1.default.parse(location.search);
            if (selectedVariant.variant.name != "Default") {
                if (!(selectedVariant.experimentName in parsed) ||
                    parsed[selectedVariant.experimentName] !=
                        selectedVariant.variant.name) {
                    parsed[selectedVariant.experimentName] =
                        selectedVariant.variant.name;
                    renderChild = arrayChild.find(function (o) { return o.props.name == "Default"; });
                    isRedirect = true;
                    redirectQuery = query_string_1.default.stringify(parsed);
                }
                else {
                    if (value.context) {
                        value.context.isCanonical = true;
                    }
                }
            }
            else {
                if (selectedVariant.experimentName in parsed) {
                    delete parsed[selectedVariant.experimentName];
                    isRedirect = true;
                    redirectQuery = query_string_1.default.stringify(parsed);
                    if (value.context) {
                        value.context.isCanonical = true;
                    }
                }
            }
            if (isRedirect) {
                if (value.context) {
                    value.context.statusCode = 302;
                    value.context.queryPart = redirectQuery;
                }
                return (react_1.default.createElement(Lifecycle, { path: redirectQuery, onMount: function () {
                        _this.redirector(redirectQuery, value.history);
                    }, onUpdate: function (self, prevProps) {
                        _this.redirector(self.props.path, value.history);
                    } }, renderChild));
            }
            else {
                return renderChild;
            }
        }));
    };
    Experiment.contextType = createContext_1.ABContext;
    return Experiment;
}(react_1.default.Component));
exports.Experiment = Experiment;
var Lifecycle = /** @class */ (function (_super) {
    __extends(Lifecycle, _super);
    function Lifecycle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lifecycle.prototype.componentDidMount = function () {
        if (this.props.onMount)
            this.props.onMount.call(this, this);
    };
    Lifecycle.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.onUpdate)
            this.props.onUpdate.call(this, this, prevProps);
    };
    Lifecycle.prototype.render = function () {
        return this.props.children;
    };
    return Lifecycle;
}(react_1.default.Component));
//# sourceMappingURL=experiment.js.map